(function () {
  function init() {
    document.querySelectorAll('[data-arriving-soon]').forEach(setupSection);
    scrollToFormIfPosted();
  }
 function scrollToHashOnLoad() {
    if (window.location.hash !== '#early-access') return;
    const target = document.getElementById('early-access');
    if (!target) return;
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  function setupSection(section) {
    const scrollers = section.querySelectorAll('[data-arriving-scroll-to-form]');
    const emailEl = section.querySelector('.arriving-soon__email');
    const form = section.querySelector('.arriving-soon__form');

    scrollers.forEach((btn) => {
      btn.addEventListener('click', () => {
        form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => emailEl?.focus(), 400);
      });
    });
  }

  function scrollToFormIfPosted() {
    const success = document.querySelector('.arriving-soon__msg--success');
    const error = document.querySelector('.arriving-soon__msg--error');
    const target = success || error;
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
